import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Divider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { WS_ACTION_TYPES, POI_ACTION_TYPES } from '../../redux-saga/actionTypes';
import {
  Header,
  FastRouteSelector,
  MoreInformation,
  Buttons,
  SelectedPoiDetails,
} from '../../components';
import styles from './styles';

class PoiDetails extends React.Component {
  componentWillMount() {
    const {
      poiDetailUpdateEvent,
      saveSelectedPoi,
      saveIncomingStop,
      addStopInProgressStatus,
    } = this.props;
    poiDetailUpdateEvent(payload => {
      if (!addStopInProgressStatus) saveSelectedPoi(payload);
    });
    poiDetailUpdateEvent(payload => {
      if (addStopInProgressStatus) saveIncomingStop(payload);
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Header />
        <SelectedPoiDetails />
        <section className={classes.footer__container}>
          <FastRouteSelector />
          <span className={classes.divider}>
            <Divider />
          </span>
          <MoreInformation />
          <Buttons />
        </section>
      </React.Fragment>
    );
  }
}

PoiDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  poiDetailUpdateEvent: PropTypes.func.isRequired,
  saveSelectedPoi: PropTypes.func.isRequired,
  addStopInProgressStatus: PropTypes.bool,
  saveIncomingStop: PropTypes.func.isRequired,
};

PoiDetails.defaultProps = {
  addStopInProgressStatus: false,
};

const mapStateToProps = ({ poi }) => ({
  addStopInProgressStatus: poi.stops_inprogress,
});

const mapDispatchToProps = dispatch => ({
  saveSelectedPoi: payload => dispatch({ type: POI_ACTION_TYPES.POI_SELECTED.LOADING, payload }),
  poiDetailUpdateEvent: payload =>
    dispatch({ type: WS_ACTION_TYPES.WS.ON_MESSAGES_DETAIL_UPDATE, payload }),
  saveIncomingStop: payload => dispatch({ type: POI_ACTION_TYPES.INCOMING_STOP, payload }),
});
export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(PoiDetails)),
);
